import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "row pt-3",
  style: {"border-top":"1px dashed rgba(106, 113, 133, 0.3)"}
}
const _hoisted_2 = { class: "col-sm-6" }
const _hoisted_3 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_4 = { class: "form-check" }
const _hoisted_5 = {
  class: "form-check-label",
  for: "Single-Item-Select"
}
const _hoisted_6 = { class: "col-sm-6" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "f-w-700" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_12 = { class: "form-check" }
const _hoisted_13 = {
  class: "form-check-label",
  for: "ageVerificationRequired"
}
const _hoisted_14 = { class: "col-sm-6" }
const _hoisted_15 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_16 = { class: "form-check" }
const _hoisted_17 = {
  class: "form-check-label",
  for: "noMembershipDiscountAllowed"
}
const _hoisted_18 = { class: "col-sm-6" }
const _hoisted_19 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_20 = { class: "form-check" }
const _hoisted_21 = {
  class: "form-check-label",
  for: "nonDiscountable"
}
const _hoisted_22 = { class: "col-sm-6" }
const _hoisted_23 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_24 = { class: "form-check" }
const _hoisted_25 = {
  class: "form-check-label",
  for: "nonSurchargeable"
}

import { computed, reactive, watch, onMounted } from 'vue'
import { useProductsStore } from '@/store/management/productsStore';

import { useI18n } from 'vue-i18n'
import { productMiscellaneousLanguage } from '@/core/locales/products-language'


export default /*@__PURE__*/_defineComponent({
  __name: 'productMiscellneous',
  setup(__props) {

const { t } = useI18n({
  messages: productMiscellaneousLanguage
})

const productStore = useProductsStore()

onMounted(() => {
    if (tempActiveProduct.value?.basic.productNumber) {
        const productGroup = tempActiveProduct.value
        const miscellaneousData = productGroup.miscellaneous
        compState.requiredMemo = miscellaneousData.requiredMemo
        compState.memo = miscellaneousData.memo
        compState.ageVerificationRequired = miscellaneousData.ageVerificationRequired
        compState.noMembershipDiscountAllowed = miscellaneousData.noMembershipDiscountAllowed
        compState.nonDiscountable = miscellaneousData.nonDiscountable
        compState.nonSurchargeable = miscellaneousData.nonSurchargeable
    }
})

const compState = reactive({
    requiredMemo: false,
    memo: '',
    ageVerificationRequired: false,
    noMembershipDiscountAllowed: false,
    nonDiscountable: false,
    nonSurchargeable: false
})


const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

watch(activeProductId, (newVal) => {
    if (newVal) {
        const productGroup = activeProduct.value
        const miscellaneousData = productGroup.miscellaneous
        compState.requiredMemo = miscellaneousData.requiredMemo
        compState.memo = miscellaneousData.memo
        compState.ageVerificationRequired = miscellaneousData.ageVerificationRequired
        compState.noMembershipDiscountAllowed = miscellaneousData.noMembershipDiscountAllowed
        compState.nonDiscountable = miscellaneousData.nonDiscountable
        compState.nonSurchargeable = miscellaneousData.nonSurchargeable
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        miscellaneous: {
            requiredMemo: newVal.requiredMemo,
            memo: newVal.memo,
            ageVerificationRequired: newVal.ageVerificationRequired,
            noMembershipDiscountAllowed: newVal.noMembershipDiscountAllowed,
            nonDiscountable: newVal.nonDiscountable,
            nonSurchargeable: newVal.nonSurchargeable
        }
    })

}, { deep: true });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            id: "Single-Item-Select",
            type: "checkbox",
            value: "",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compState.requiredMemo) = $event))
          }, null, 512), [
            [_vModelCheckbox, compState.requiredMemo]
          ]),
          _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(t)('Memo Required')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("label", null, [
          _createElementVNode("h6", _hoisted_8, _toDisplayString(_unref(t)('Memo')), 1)
        ]),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compState.memo) = $event)),
          class: "form-control",
          type: "text",
          placeholder: _unref(t)('Name'),
          maxlength: "32"
        }, null, 8, _hoisted_9), [
          [_vModelText, compState.memo]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            id: "ageVerificationRequired",
            type: "checkbox",
            value: "",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((compState.ageVerificationRequired) = $event))
          }, null, 512), [
            [_vModelCheckbox, compState.ageVerificationRequired]
          ]),
          _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(t)('Age Verification Required')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            id: "noMembershipDiscountAllowed",
            type: "checkbox",
            value: "",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((compState.noMembershipDiscountAllowed) = $event))
          }, null, 512), [
            [_vModelCheckbox, compState.noMembershipDiscountAllowed]
          ]),
          _createElementVNode("label", _hoisted_17, _toDisplayString(_unref(t)('No Membership Discount Allowed')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            id: "nonDiscountable",
            type: "checkbox",
            value: "",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((compState.nonDiscountable) = $event))
          }, null, 512), [
            [_vModelCheckbox, compState.nonDiscountable]
          ]),
          _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(t)('Non Discountable')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            id: "nonSurchargeable",
            type: "checkbox",
            value: "",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((compState.nonSurchargeable) = $event))
          }, null, 512), [
            [_vModelCheckbox, compState.nonSurchargeable]
          ]),
          _createElementVNode("label", _hoisted_25, _toDisplayString(_unref(t)('Non Surchargeable')), 1)
        ])
      ])
    ])
  ]))
}
}

})